import Vue from 'vue'
import HubspotTracking from 'chimera/all/plugins/tracking/hubspot'

export default ({ store }) => {
  Vue.use(HubspotTracking, {
    store,
  })
}
